import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.css']
})
export class StaticContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
